<template>
  <div class="stockBreadCrumb">
    <el-breadcrumb-item>库存管理</el-breadcrumb-item>
    <el-breadcrumb-item :class="{ active: item.url===$route.path }" :to="item.url" v-for="item in breadcrumbList" :key="item.id">{{item.name}}</el-breadcrumb-item>
  </div>
</template>
<script>
export default {
  data () {
    return {
      breadcrumbList: [],
      stockList: [
        { url: '/stock/manage', name: '库存管理' },
        { url: '/stock/stockRecord', name: '导入记录' }
      ]
    }
  },
  mounted () {
    this.setBreadCrumb(this.$route)
  },
  watch: {
    $route (to, from) {
      this.setBreadCrumb(to)
    }
  },
  methods: {
    setBreadCrumb (to) {
      let currentUrl = this.stockList.filter(item => item.url === to.path)
      if (!this.breadcrumbList.some(item => item.url === to.path)) {
        this.breadcrumbList = this.breadcrumbList.concat(currentUrl)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/breadcrumb/stockBreadCrumb.vue